// 月初现金余额管理
export default {
  monthCashBalance: {
    column: {
      businessCompany: '公司',
      businessDepartment: '部门',
      fundYear: '年度',
      fundMonth: '月份',
      fundBalanceBeginning: '月初现金占用',
    },
    placeholder: {
      businessCompanyPlaceholder: '请选择公司',
      businessDepartmentPlaceholder: '请选择部门',
      fundYearPlaceholder: '请选择年度',
      fundMonthPlaceholder: '请选择月份',
      fundBalanceBeginningPlaceholder: '请输入月初现金占用',
    },
    button: {
      save: '保存',
      add: '新增',
      delete: '删除',
    },
    message: {
      noSelected: '您还未选择任何数据!',
      noForbid: '失效状态不能编辑！',
      onlyOneSelectData: '请选择一条数据进行操作!',
      noExport: '当前没有数据可以导出！',
      saveSussess: '保存成功！',
      saveFail: '保存失败！',
      select: '请选择一条数据操作，或直接点击行数据编辑',
    },
  },
};
